import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from '@material-ui/core'
import useTranslator from 'utils/hooks/Translator'

const useStyles = makeStyles(() => ({
  dialog: {
    borderRadius: 8,
    padding: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: 500,
    color: '#0E1039',
    margin: 0,
    padding: '0 0 1rem 0',
  },
  content: {
    padding: '0 0 2rem 0',
  },
  actions: {
    padding: '0 0',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 16,
  },
}))

interface ModalConfirmExitProps {
  isOpen: boolean
  onClose: () => void
  onSave: () => void
  onCancel: () => void
}

export default function ModalConfirmExit({
  isOpen,
  onClose,
  onSave,
  onCancel,
}: ModalConfirmExitProps) {
  const classes = useStyles()
  const { getTranslation } = useTranslator()

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableBackdropClick
      classes={{ paper: classes.dialog }}
    >
      <DialogTitle disableTypography className={classes.title}>
        {getTranslation('modal.confirmExit.title')}
      </DialogTitle>

      <DialogContent className={classes.content}>
        <DialogContentText>
          {getTranslation('modal.confirmExit.message')}
        </DialogContentText>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          {getTranslation('modal.confirmExit.cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={onSave}>
          {getTranslation('modal.confirmExit.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
